import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unblockMissionTrackingPas(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.unblockMissionTrackingPas.url, { id }))
    .post()
}
